<template>
  <div class="pg-dialog-select-refer-input">
    <PgInput
      class="dialog-table-input__input"
      :placeholder="placeholder"
      :value="value"
      @input="onInput"
      :disabled="disabled"
    />
    <ElButton
      class="dialog-table-input__btn"
      type="text"
      icon="ivu-icon-icon-pg-xz"
      @click.stop="showEvent"
      v-if="!disabled"
      >{{ btnText }}</ElButton
    >
    <PgSelentMain
      v-if="showRander"
      v-bind="$attrs"
      :multiple="false"
      seqShow
      valueIsObj
      :selectionKey="selectionKey"
      :url="url"
      :method="method"
      :paramater="paramater"
      :visible="visible"
      :checkboxConfig="checkboxConfig"
      :pageSize="pageSize"
      :seachPlaceholder="seachPlaceholder"
      @on-cancel="onCancel"
      @on-ok="onOk"
    ></PgSelentMain>
  </div>
</template>
<script>
export default {
  inheritAttrs: false,
}
</script>
<script setup>
import PgSelentMain from './main.vue'
import { PgInput } from '../../input/index'
import {
  beforValueOldActionProps,
  useBeforValueOldActions,
  useComponentDefault,
} from '../../../hooks/index'
import { useDisplay } from '../hook/use-display'
import { http, getValueByPath, clone, setValueByPath } from '../../../utils/index'

const props = defineProps({
  value: [String],
  btnText: {
    type: String,
    default: '手动选择',
  },
  checkboxConfig: Object,
  //选中项是否是对象
  valueIsObj: Boolean,
  // 只在valueIsObj为true时使用，在手动在输入框中输入时，会在valueIsObjData中将selectionKey的值设置为手动输入的值再将valueIsObjData抛出
  valueIsObjData: Object,
  //选中项的唯一值，当valueIsObj为true时直接返回查询接口返回的结构，否则返回查询接口返回的selectionKey对应的值
  selectionKey: {
    type: String,
    default: 'id',
  },
  url: String,
  method: {
    type: String,
    default: 'post',
  },
  paramater: Object,
  placeholder: {
    type: String,
    default: '请输入',
  },
  pageSize: Number,
  disabled: Boolean,
  seachPlaceholder: String,
  defaultValuePolicy: String,
  ...beforValueOldActionProps,
})

const emit = defineEmits(['input'])
const { beforeEmit } = useBeforValueOldActions({
  store: props.store,
  beforValueAction: props.beforValueAction,
  emit,
})

const { visible, showRander, showEvent, onCancel } = useDisplay(props)

useComponentDefault({
  value: props.value,
  disabled: props.disabled,
  getData: () =>
    http[props.method](
      props.url,
      Object.assign(
        { pageNo: props.pageSize > 0 ? 1 : undefined, pageSize: props.pageSize ?? undefined },
        props.paramater
      ),
      { errorTip: null }
    ),
  type: props.defaultValuePolicy,
  setVal: (val) =>
    beforeEmit(props.valueIsObj ? val : val && getValueByPath(val, props.selectionKey)),
})

const onInput = (val) => {
  if (props.valueIsObj) {
    const resVal = clone(props.valueIsObjData ?? {})
    setValueByPath(resVal, props.selectionKey, val)
    beforeEmit(resVal)
  } else {
    beforeEmit(val)
  }
}
const onOk = (val) => {
  beforeEmit(props.valueIsObj ? val : getValueByPath(val, props.selectionKey))
}
</script>
<style lang="scss">
@import '../slyle/dialog-select-refer-input.scss';
</style>
